import { createMachine } from 'xstate';
import { Context, Events } from './types';

const initialContext = {
  error: null,
} as Context;

export const changePaymentProfile = createMachine<Context, Events>({
  id: 'changePaymentProfile',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  states: {
    idle: {
      on: {
        CHANGE_PAYMENT_PROFILE: 'changePaymentProfile',
      },
    },
    changePaymentProfile: {
      invoke: {
        src: 'changePaymentProfile',
        onDone: {
          target: 'success',
          actions: 'onChangeProfileSuccess',
        },
        onError: {
          actions: 'setError',
          target: 'error',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
